import { Component } from "react";
import Toolbar from "../components/toolbar";
import '../styles/style.css';
import { isLoggedIn } from "../../App";

class Home extends Component<any,any> {

    constructor(props: any) {
        super(props);
        
        
    }

    render() {
        return (
            <div style={{height: '100%'}}>
                <Toolbar />
                <section style={{marginLeft: '200px',height: '100%',display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <div style={{}}>
                        <img src='/content/images/logo-hires.png' style={{width: '800px'}}/>
                    </div>
                </section>
            </div>

        );
    }
}

export default Home;